// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "../../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_format from "../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as PartnerStatus from "../../../../app/partner/entity/PartnerStatus.bs.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Button$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as CrmAssetsManager from "../../../../../to-be-migrated/assets/CrmAssetsManager.bs.js";
import * as MsisdnValidation from "../../../../../../../library/work-space/form/MsisdnValidation.bs.js";
import * as WorkSpaceContext from "../../../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as PartnerEngagement from "../../../../app/filter-partners/entity/PartnerEngagement.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as PartnerLoginStatus from "../../../../app/partner/entity/PartnerLoginStatus.bs.js";
import * as VehicleRepoManager from "../../../../../../../library/data-source/vehicle/repo/VehicleRepoManager.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as FilterPartnerRequest from "../../../../app/filter-partners/entity/FilterPartnerRequest.bs.js";
import * as GeoRegionRepoManager from "../../../../../../../library/data-source/geo-region/repo/GeoRegionRepoManager.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as FilterPartnerFormHelper from "./FilterPartnerFormHelper.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as SelectComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";
import * as PartnerActiveStatusFilter from "../../../../app/filter-partners/entity/PartnerActiveStatusFilter.bs.js";
import * as FormCheckBoxInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormCheckBoxInput.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

var saveButton = CrmAssetsManager.getImage("save-button.svg");

var saveButtonDisabled = CrmAssetsManager.getImage("save-button-disabled.svg");

var validators_vehicle_number = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Opt */0,
                      _0: {
                        TAG: /* String */1,
                        _0: param.vehicle_number
                      }
                    }), (function (num) {
                    if (num !== undefined && num.length !== 4) {
                      return {
                              TAG: /* Error */1,
                              _0: "Last 4 digits required"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: num
                            };
                    }
                  }));
    })
};

var validators_cluster = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      return PrimitiveFormTypes$Catalyst.getValue({
                  TAG: /* Opt */0,
                  _0: {
                    TAG: /* String */1,
                    _0: param.cluster
                  }
                });
    })
};

var validators_name = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      return PrimitiveFormTypes$Catalyst.getValue({
                  TAG: /* Opt */0,
                  _0: {
                    TAG: /* String */1,
                    _0: param.name
                  }
                });
    })
};

var validators_msisdn = {
  strategy: /* OnSubmit */4,
  validate: (function (param, metadata) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Opt */0,
                      _0: {
                        TAG: /* String */1,
                        _0: param.msisdn
                      }
                    }), (function (msisdn) {
                    if (msisdn === undefined) {
                      return {
                              TAG: /* Ok */0,
                              _0: undefined
                            };
                    }
                    var error = MsisdnValidation.execute(msisdn, metadata.country);
                    if (error.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: error._0
                            };
                    } else {
                      return {
                              TAG: /* Error */1,
                              _0: error._0
                            };
                    }
                  }));
    })
};

var validators_active_status = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var active_status = param.active_status;
      if (active_status !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: PartnerActiveStatusFilter.from_string(active_status.value)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_login_status = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var login_status = param.login_status;
      if (login_status !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: PartnerLoginStatus.fromString(login_status.value)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_status = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var status = param.status;
      if (status) {
        return {
                TAG: /* Ok */0,
                _0: List.map(PartnerStatus.fromString, status)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_gps_location = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      if (param.gps_location) {
        return {
                TAG: /* Ok */0,
                _0: true
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_availability = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      if (param.availability) {
        return {
                TAG: /* Ok */0,
                _0: true
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_engagement_type = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var engagement_type = param.engagement_type;
      if (engagement_type) {
        return {
                TAG: /* Ok */0,
                _0: List.map(PartnerEngagement.from_string, engagement_type)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_vehicle_type = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var vehicle_type = param.vehicle_type;
      if (vehicle_type !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: Caml_format.caml_int_of_string(vehicle_type.value)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_city = {
  strategy: /* OnFirstChange */1,
  validate: (function (param, param$1) {
      var city = param.city;
      if (city !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: Caml_format.caml_int_of_string(city.value)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "City Required!"
              };
      }
    })
};

var validators = {
  vehicle_number: validators_vehicle_number,
  cluster: validators_cluster,
  name: validators_name,
  msisdn: validators_msisdn,
  active_status: validators_active_status,
  login_status: validators_login_status,
  status: validators_status,
  gps_location: validators_gps_location,
  availability: validators_availability,
  engagement_type: validators_engagement_type,
  vehicle_type: validators_vehicle_type,
  city: validators_city
};

function initialFieldsStatuses(_input) {
  return {
          vehicle_number: /* Pristine */0,
          cluster: /* Pristine */0,
          name: /* Pristine */0,
          msisdn: /* Pristine */0,
          active_status: /* Pristine */0,
          login_status: /* Pristine */0,
          status: /* Pristine */0,
          gps_location: /* Pristine */0,
          availability: /* Pristine */0,
          engagement_type: /* Pristine */0,
          vehicle_type: /* Pristine */0,
          city: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.vehicle_number;
  var match_0 = match ? match._0 : Curry._2(validators.vehicle_number.validate, input, metadata);
  var match$1 = fieldsStatuses.cluster;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.cluster.validate, input, metadata);
  var match$2 = fieldsStatuses.name;
  var match_0$2 = match$2 ? match$2._0 : Curry._2(validators.name.validate, input, metadata);
  var match$3 = fieldsStatuses.msisdn;
  var match_0$3 = match$3 ? match$3._0 : Curry._2(validators.msisdn.validate, input, metadata);
  var match$4 = fieldsStatuses.active_status;
  var match_0$4 = match$4 ? match$4._0 : Curry._2(validators.active_status.validate, input, metadata);
  var match$5 = fieldsStatuses.login_status;
  var match_0$5 = match$5 ? match$5._0 : Curry._2(validators.login_status.validate, input, metadata);
  var match$6 = fieldsStatuses.status;
  var match_0$6 = match$6 ? match$6._0 : Curry._2(validators.status.validate, input, metadata);
  var match$7 = fieldsStatuses.gps_location;
  var match_0$7 = match$7 ? match$7._0 : Curry._2(validators.gps_location.validate, input, metadata);
  var match$8 = fieldsStatuses.availability;
  var match_0$8 = match$8 ? match$8._0 : Curry._2(validators.availability.validate, input, metadata);
  var match$9 = fieldsStatuses.engagement_type;
  var match_0$9 = match$9 ? match$9._0 : Curry._2(validators.engagement_type.validate, input, metadata);
  var match$10 = fieldsStatuses.vehicle_type;
  var match_0$10 = match$10 ? match$10._0 : Curry._2(validators.vehicle_type.validate, input, metadata);
  var match$11 = fieldsStatuses.city;
  var match_0$11 = match$11 ? match$11._0 : Curry._2(validators.city.validate, input, metadata);
  var vehicle_numberResult = match_0;
  var vehicle_numberResult$1;
  if (vehicle_numberResult.TAG === /* Ok */0) {
    var clusterResult = match_0$1;
    if (clusterResult.TAG === /* Ok */0) {
      var nameResult = match_0$2;
      if (nameResult.TAG === /* Ok */0) {
        var msisdnResult = match_0$3;
        if (msisdnResult.TAG === /* Ok */0) {
          var active_statusResult = match_0$4;
          if (active_statusResult.TAG === /* Ok */0) {
            var login_statusResult = match_0$5;
            if (login_statusResult.TAG === /* Ok */0) {
              var statusResult = match_0$6;
              if (statusResult.TAG === /* Ok */0) {
                var gps_locationResult = match_0$7;
                if (gps_locationResult.TAG === /* Ok */0) {
                  var availabilityResult = match_0$8;
                  if (availabilityResult.TAG === /* Ok */0) {
                    var engagement_typeResult = match_0$9;
                    if (engagement_typeResult.TAG === /* Ok */0) {
                      var vehicle_typeResult = match_0$10;
                      if (vehicle_typeResult.TAG === /* Ok */0) {
                        var cityResult = match_0$11;
                        if (cityResult.TAG === /* Ok */0) {
                          return {
                                  TAG: /* Valid */0,
                                  output: {
                                    city: cityResult._0,
                                    vehicle_type: vehicle_typeResult._0,
                                    engagement_type: engagement_typeResult._0,
                                    availability: availabilityResult._0,
                                    gps_location: gps_locationResult._0,
                                    status: statusResult._0,
                                    login_status: login_statusResult._0,
                                    active_status: active_statusResult._0,
                                    msisdn: msisdnResult._0,
                                    name: nameResult._0,
                                    cluster: clusterResult._0,
                                    vehicle_number: vehicle_numberResult._0
                                  },
                                  fieldsStatuses: {
                                    vehicle_number: /* Dirty */{
                                      _0: vehicle_numberResult,
                                      _1: /* Shown */0
                                    },
                                    cluster: /* Dirty */{
                                      _0: clusterResult,
                                      _1: /* Shown */0
                                    },
                                    name: /* Dirty */{
                                      _0: nameResult,
                                      _1: /* Shown */0
                                    },
                                    msisdn: /* Dirty */{
                                      _0: msisdnResult,
                                      _1: /* Shown */0
                                    },
                                    active_status: /* Dirty */{
                                      _0: active_statusResult,
                                      _1: /* Shown */0
                                    },
                                    login_status: /* Dirty */{
                                      _0: login_statusResult,
                                      _1: /* Shown */0
                                    },
                                    status: /* Dirty */{
                                      _0: statusResult,
                                      _1: /* Shown */0
                                    },
                                    gps_location: /* Dirty */{
                                      _0: gps_locationResult,
                                      _1: /* Shown */0
                                    },
                                    availability: /* Dirty */{
                                      _0: availabilityResult,
                                      _1: /* Shown */0
                                    },
                                    engagement_type: /* Dirty */{
                                      _0: engagement_typeResult,
                                      _1: /* Shown */0
                                    },
                                    vehicle_type: /* Dirty */{
                                      _0: vehicle_typeResult,
                                      _1: /* Shown */0
                                    },
                                    city: /* Dirty */{
                                      _0: cityResult,
                                      _1: /* Shown */0
                                    }
                                  },
                                  collectionsStatuses: undefined
                                };
                        }
                        vehicle_numberResult$1 = vehicle_numberResult;
                      } else {
                        vehicle_numberResult$1 = vehicle_numberResult;
                      }
                    } else {
                      vehicle_numberResult$1 = vehicle_numberResult;
                    }
                  } else {
                    vehicle_numberResult$1 = vehicle_numberResult;
                  }
                } else {
                  vehicle_numberResult$1 = vehicle_numberResult;
                }
              } else {
                vehicle_numberResult$1 = vehicle_numberResult;
              }
            } else {
              vehicle_numberResult$1 = vehicle_numberResult;
            }
          } else {
            vehicle_numberResult$1 = vehicle_numberResult;
          }
        } else {
          vehicle_numberResult$1 = vehicle_numberResult;
        }
      } else {
        vehicle_numberResult$1 = vehicle_numberResult;
      }
    } else {
      vehicle_numberResult$1 = vehicle_numberResult;
    }
  } else {
    vehicle_numberResult$1 = vehicle_numberResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            vehicle_number: /* Dirty */{
              _0: vehicle_numberResult$1,
              _1: /* Shown */0
            },
            cluster: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            name: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            msisdn: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            active_status: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            },
            login_status: /* Dirty */{
              _0: match_0$5,
              _1: /* Shown */0
            },
            status: /* Dirty */{
              _0: match_0$6,
              _1: /* Shown */0
            },
            gps_location: /* Dirty */{
              _0: match_0$7,
              _1: /* Shown */0
            },
            availability: /* Dirty */{
              _0: match_0$8,
              _1: /* Shown */0
            },
            engagement_type: /* Dirty */{
              _0: match_0$9,
              _1: /* Shown */0
            },
            vehicle_type: /* Dirty */{
              _0: match_0$10,
              _1: /* Shown */0
            },
            city: /* Dirty */{
              _0: match_0$11,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurVehicle_numberField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.vehicle_number, validators_vehicle_number, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  vehicle_number: status,
                                  cluster: init.cluster,
                                  name: init.name,
                                  msisdn: init.msisdn,
                                  active_status: init.active_status,
                                  login_status: init.login_status,
                                  status: init.status,
                                  gps_location: init.gps_location,
                                  availability: init.availability,
                                  engagement_type: init.engagement_type,
                                  vehicle_type: init.vehicle_type,
                                  city: init.city
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurClusterField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.cluster, validators_cluster, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  vehicle_number: init.vehicle_number,
                                  cluster: status,
                                  name: init.name,
                                  msisdn: init.msisdn,
                                  active_status: init.active_status,
                                  login_status: init.login_status,
                                  status: init.status,
                                  gps_location: init.gps_location,
                                  availability: init.availability,
                                  engagement_type: init.engagement_type,
                                  vehicle_type: init.vehicle_type,
                                  city: init.city
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurNameField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.name, validators_name, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  vehicle_number: init.vehicle_number,
                                  cluster: init.cluster,
                                  name: status,
                                  msisdn: init.msisdn,
                                  active_status: init.active_status,
                                  login_status: init.login_status,
                                  status: init.status,
                                  gps_location: init.gps_location,
                                  availability: init.availability,
                                  engagement_type: init.engagement_type,
                                  vehicle_type: init.vehicle_type,
                                  city: init.city
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurMsisdnField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.msisdn, validators_msisdn, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  vehicle_number: init.vehicle_number,
                                  cluster: init.cluster,
                                  name: init.name,
                                  msisdn: status,
                                  active_status: init.active_status,
                                  login_status: init.login_status,
                                  status: init.status,
                                  gps_location: init.gps_location,
                                  availability: init.availability,
                                  engagement_type: init.engagement_type,
                                  vehicle_type: init.vehicle_type,
                                  city: init.city
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurActive_statusField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.active_status, validators_active_status, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  vehicle_number: init.vehicle_number,
                                  cluster: init.cluster,
                                  name: init.name,
                                  msisdn: init.msisdn,
                                  active_status: status,
                                  login_status: init.login_status,
                                  status: init.status,
                                  gps_location: init.gps_location,
                                  availability: init.availability,
                                  engagement_type: init.engagement_type,
                                  vehicle_type: init.vehicle_type,
                                  city: init.city
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurLogin_statusField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.login_status, validators_login_status, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  vehicle_number: init.vehicle_number,
                                  cluster: init.cluster,
                                  name: init.name,
                                  msisdn: init.msisdn,
                                  active_status: init.active_status,
                                  login_status: status,
                                  status: init.status,
                                  gps_location: init.gps_location,
                                  availability: init.availability,
                                  engagement_type: init.engagement_type,
                                  vehicle_type: init.vehicle_type,
                                  city: init.city
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStatusField */6 :
                  var result$6 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.status, validators_status, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  vehicle_number: init.vehicle_number,
                                  cluster: init.cluster,
                                  name: init.name,
                                  msisdn: init.msisdn,
                                  active_status: init.active_status,
                                  login_status: init.login_status,
                                  status: status,
                                  gps_location: init.gps_location,
                                  availability: init.availability,
                                  engagement_type: init.engagement_type,
                                  vehicle_type: init.vehicle_type,
                                  city: init.city
                                };
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurGps_locationField */7 :
                  var result$7 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.gps_location, validators_gps_location, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  vehicle_number: init.vehicle_number,
                                  cluster: init.cluster,
                                  name: init.name,
                                  msisdn: init.msisdn,
                                  active_status: init.active_status,
                                  login_status: init.login_status,
                                  status: init.status,
                                  gps_location: status,
                                  availability: init.availability,
                                  engagement_type: init.engagement_type,
                                  vehicle_type: init.vehicle_type,
                                  city: init.city
                                };
                        }));
                  if (result$7 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$7,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurAvailabilityField */8 :
                  var result$8 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.availability, validators_availability, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  vehicle_number: init.vehicle_number,
                                  cluster: init.cluster,
                                  name: init.name,
                                  msisdn: init.msisdn,
                                  active_status: init.active_status,
                                  login_status: init.login_status,
                                  status: init.status,
                                  gps_location: init.gps_location,
                                  availability: status,
                                  engagement_type: init.engagement_type,
                                  vehicle_type: init.vehicle_type,
                                  city: init.city
                                };
                        }));
                  if (result$8 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$8,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurEngagement_typeField */9 :
                  var result$9 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.engagement_type, validators_engagement_type, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  vehicle_number: init.vehicle_number,
                                  cluster: init.cluster,
                                  name: init.name,
                                  msisdn: init.msisdn,
                                  active_status: init.active_status,
                                  login_status: init.login_status,
                                  status: init.status,
                                  gps_location: init.gps_location,
                                  availability: init.availability,
                                  engagement_type: status,
                                  vehicle_type: init.vehicle_type,
                                  city: init.city
                                };
                        }));
                  if (result$9 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$9,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurVehicle_typeField */10 :
                  var result$10 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.vehicle_type, validators_vehicle_type, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  vehicle_number: init.vehicle_number,
                                  cluster: init.cluster,
                                  name: init.name,
                                  msisdn: init.msisdn,
                                  active_status: init.active_status,
                                  login_status: init.login_status,
                                  status: init.status,
                                  gps_location: init.gps_location,
                                  availability: init.availability,
                                  engagement_type: init.engagement_type,
                                  vehicle_type: status,
                                  city: init.city
                                };
                        }));
                  if (result$10 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$10,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCityField */11 :
                  var result$11 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.city, validators_city, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  vehicle_number: init.vehicle_number,
                                  cluster: init.cluster,
                                  name: init.name,
                                  msisdn: init.msisdn,
                                  active_status: init.active_status,
                                  login_status: init.login_status,
                                  status: init.status,
                                  gps_location: init.gps_location,
                                  availability: init.availability,
                                  engagement_type: init.engagement_type,
                                  vehicle_type: init.vehicle_type,
                                  city: status
                                };
                        }));
                  if (result$11 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$11,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */12 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */12,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */13,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */15);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */14);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */13 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */14 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */15 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateVehicle_numberField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.vehicle_number, state.submissionStatus, validators_vehicle_number, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            vehicle_number: status,
                                            cluster: init.cluster,
                                            name: init.name,
                                            msisdn: init.msisdn,
                                            active_status: init.active_status,
                                            login_status: init.login_status,
                                            status: init.status,
                                            gps_location: init.gps_location,
                                            availability: init.availability,
                                            engagement_type: init.engagement_type,
                                            vehicle_type: init.vehicle_type,
                                            city: init.city
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateClusterField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.cluster, state.submissionStatus, validators_cluster, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            vehicle_number: init.vehicle_number,
                                            cluster: status,
                                            name: init.name,
                                            msisdn: init.msisdn,
                                            active_status: init.active_status,
                                            login_status: init.login_status,
                                            status: init.status,
                                            gps_location: init.gps_location,
                                            availability: init.availability,
                                            engagement_type: init.engagement_type,
                                            vehicle_type: init.vehicle_type,
                                            city: init.city
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateNameField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.name, state.submissionStatus, validators_name, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            vehicle_number: init.vehicle_number,
                                            cluster: init.cluster,
                                            name: status,
                                            msisdn: init.msisdn,
                                            active_status: init.active_status,
                                            login_status: init.login_status,
                                            status: init.status,
                                            gps_location: init.gps_location,
                                            availability: init.availability,
                                            engagement_type: init.engagement_type,
                                            vehicle_type: init.vehicle_type,
                                            city: init.city
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateMsisdnField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, state.fieldsStatuses.msisdn, state.submissionStatus, validators_msisdn, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            vehicle_number: init.vehicle_number,
                                            cluster: init.cluster,
                                            name: init.name,
                                            msisdn: status,
                                            active_status: init.active_status,
                                            login_status: init.login_status,
                                            status: init.status,
                                            gps_location: init.gps_location,
                                            availability: init.availability,
                                            engagement_type: init.engagement_type,
                                            vehicle_type: init.vehicle_type,
                                            city: init.city
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateActive_statusField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$4, metadata, state.fieldsStatuses.active_status, state.submissionStatus, validators_active_status, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            vehicle_number: init.vehicle_number,
                                            cluster: init.cluster,
                                            name: init.name,
                                            msisdn: init.msisdn,
                                            active_status: status,
                                            login_status: init.login_status,
                                            status: init.status,
                                            gps_location: init.gps_location,
                                            availability: init.availability,
                                            engagement_type: init.engagement_type,
                                            vehicle_type: init.vehicle_type,
                                            city: init.city
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateLogin_statusField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$5, metadata, state.fieldsStatuses.login_status, state.submissionStatus, validators_login_status, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            vehicle_number: init.vehicle_number,
                                            cluster: init.cluster,
                                            name: init.name,
                                            msisdn: init.msisdn,
                                            active_status: init.active_status,
                                            login_status: status,
                                            status: init.status,
                                            gps_location: init.gps_location,
                                            availability: init.availability,
                                            engagement_type: init.engagement_type,
                                            vehicle_type: init.vehicle_type,
                                            city: init.city
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStatusField */6 :
                  var nextInput$6 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$6, metadata, state.fieldsStatuses.status, state.submissionStatus, validators_status, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            vehicle_number: init.vehicle_number,
                                            cluster: init.cluster,
                                            name: init.name,
                                            msisdn: init.msisdn,
                                            active_status: init.active_status,
                                            login_status: init.login_status,
                                            status: status,
                                            gps_location: init.gps_location,
                                            availability: init.availability,
                                            engagement_type: init.engagement_type,
                                            vehicle_type: init.vehicle_type,
                                            city: init.city
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateGps_locationField */7 :
                  var nextInput$7 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$7,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$7, metadata, state.fieldsStatuses.gps_location, state.submissionStatus, validators_gps_location, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            vehicle_number: init.vehicle_number,
                                            cluster: init.cluster,
                                            name: init.name,
                                            msisdn: init.msisdn,
                                            active_status: init.active_status,
                                            login_status: init.login_status,
                                            status: init.status,
                                            gps_location: status,
                                            availability: init.availability,
                                            engagement_type: init.engagement_type,
                                            vehicle_type: init.vehicle_type,
                                            city: init.city
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateAvailabilityField */8 :
                  var nextInput$8 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$8,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$8, metadata, state.fieldsStatuses.availability, state.submissionStatus, validators_availability, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            vehicle_number: init.vehicle_number,
                                            cluster: init.cluster,
                                            name: init.name,
                                            msisdn: init.msisdn,
                                            active_status: init.active_status,
                                            login_status: init.login_status,
                                            status: init.status,
                                            gps_location: init.gps_location,
                                            availability: status,
                                            engagement_type: init.engagement_type,
                                            vehicle_type: init.vehicle_type,
                                            city: init.city
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateEngagement_typeField */9 :
                  var nextInput$9 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$9,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$9, metadata, state.fieldsStatuses.engagement_type, state.submissionStatus, validators_engagement_type, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            vehicle_number: init.vehicle_number,
                                            cluster: init.cluster,
                                            name: init.name,
                                            msisdn: init.msisdn,
                                            active_status: init.active_status,
                                            login_status: init.login_status,
                                            status: init.status,
                                            gps_location: init.gps_location,
                                            availability: init.availability,
                                            engagement_type: status,
                                            vehicle_type: init.vehicle_type,
                                            city: init.city
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateVehicle_typeField */10 :
                  var nextInput$10 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$10,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$10, metadata, state.fieldsStatuses.vehicle_type, state.submissionStatus, validators_vehicle_type, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            vehicle_number: init.vehicle_number,
                                            cluster: init.cluster,
                                            name: init.name,
                                            msisdn: init.msisdn,
                                            active_status: init.active_status,
                                            login_status: init.login_status,
                                            status: init.status,
                                            gps_location: init.gps_location,
                                            availability: init.availability,
                                            engagement_type: init.engagement_type,
                                            vehicle_type: status,
                                            city: init.city
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCityField */11 :
                  var nextInput$11 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$11,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$11, metadata, state.fieldsStatuses.city, state.submissionStatus, validators_city, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            vehicle_number: init.vehicle_number,
                                            cluster: init.cluster,
                                            name: init.name,
                                            msisdn: init.msisdn,
                                            active_status: init.active_status,
                                            login_status: init.login_status,
                                            status: init.status,
                                            gps_location: init.gps_location,
                                            availability: init.availability,
                                            engagement_type: init.engagement_type,
                                            vehicle_type: init.vehicle_type,
                                            city: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */12 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */13 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */14 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateVehicle_number: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateVehicle_numberField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCluster: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateClusterField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateName: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateNameField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateMsisdn: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateMsisdnField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateActive_status: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateActive_statusField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateLogin_status: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateLogin_statusField */5,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateStatus: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateStatusField */6,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateGps_location: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateGps_locationField */7,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateAvailability: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateAvailabilityField */8,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateEngagement_type: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEngagement_typeField */9,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateVehicle_type: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateVehicle_typeField */10,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCity: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCityField */11,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurVehicle_number: (function (param) {
              return Curry._1(dispatch, /* BlurVehicle_numberField */0);
            }),
          blurCluster: (function (param) {
              return Curry._1(dispatch, /* BlurClusterField */1);
            }),
          blurName: (function (param) {
              return Curry._1(dispatch, /* BlurNameField */2);
            }),
          blurMsisdn: (function (param) {
              return Curry._1(dispatch, /* BlurMsisdnField */3);
            }),
          blurActive_status: (function (param) {
              return Curry._1(dispatch, /* BlurActive_statusField */4);
            }),
          blurLogin_status: (function (param) {
              return Curry._1(dispatch, /* BlurLogin_statusField */5);
            }),
          blurStatus: (function (param) {
              return Curry._1(dispatch, /* BlurStatusField */6);
            }),
          blurGps_location: (function (param) {
              return Curry._1(dispatch, /* BlurGps_locationField */7);
            }),
          blurAvailability: (function (param) {
              return Curry._1(dispatch, /* BlurAvailabilityField */8);
            }),
          blurEngagement_type: (function (param) {
              return Curry._1(dispatch, /* BlurEngagement_typeField */9);
            }),
          blurVehicle_type: (function (param) {
              return Curry._1(dispatch, /* BlurVehicle_typeField */10);
            }),
          blurCity: (function (param) {
              return Curry._1(dispatch, /* BlurCityField */11);
            }),
          vehicle_numberResult: Formality.exposeFieldResult(state.fieldsStatuses.vehicle_number),
          clusterResult: Formality.exposeFieldResult(state.fieldsStatuses.cluster),
          nameResult: Formality.exposeFieldResult(state.fieldsStatuses.name),
          msisdnResult: Formality.exposeFieldResult(state.fieldsStatuses.msisdn),
          active_statusResult: Formality.exposeFieldResult(state.fieldsStatuses.active_status),
          login_statusResult: Formality.exposeFieldResult(state.fieldsStatuses.login_status),
          statusResult: Formality.exposeFieldResult(state.fieldsStatuses.status),
          gps_locationResult: Formality.exposeFieldResult(state.fieldsStatuses.gps_location),
          availabilityResult: Formality.exposeFieldResult(state.fieldsStatuses.availability),
          engagement_typeResult: Formality.exposeFieldResult(state.fieldsStatuses.engagement_type),
          vehicle_typeResult: Formality.exposeFieldResult(state.fieldsStatuses.vehicle_type),
          cityResult: Formality.exposeFieldResult(state.fieldsStatuses.city),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (!match.vehicle_number && !match.cluster && !match.name && !match.msisdn && !match.active_status && !match.login_status && !match.status && !match.gps_location && !match.availability && !match.engagement_type && !match.vehicle_type && !match.city) {
                return false;
              }
              return true;
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */12);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */13);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */14);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */14,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */15);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getInitialState(cityOptions, vehicleTypeOptions, filter) {
  var city = filter.geo_region_id;
  var city$1 = city !== undefined ? List.find_opt((function (cityOption) {
            return cityOption.value === String(city);
          }), cityOptions) : List.nth_opt(cityOptions, 0);
  return {
          city: city$1,
          vehicle_type: Belt_Option.mapWithDefault(filter.vehicle_id, undefined, (function (vehicle_id) {
                  return List.find_opt((function (vehicleTypeOption) {
                                return vehicleTypeOption.value === String(vehicle_id);
                              }), vehicleTypeOptions);
                })),
          engagement_type: Belt_Option.mapWithDefault(filter.engagement_type, /* [] */0, (function (param) {
                  return List.map(PartnerEngagement.to_string, param);
                })),
          availability: Belt_Option.mapWithDefault(filter.availability, /* [] */0, (function (param) {
                  return {
                          hd: "available",
                          tl: /* [] */0
                        };
                })),
          gps_location: Belt_Option.mapWithDefault(filter.gps_location, /* [] */0, (function (param) {
                  return {
                          hd: "location_not_updated",
                          tl: /* [] */0
                        };
                })),
          status: Belt_Option.mapWithDefault(filter.status, /* [] */0, (function (param) {
                  return List.map(PartnerStatus.toString, param);
                })),
          login_status: FormSelectInput$Catalyst.SelectUtils.getSelectComponentItem(filter.login_status, PartnerLoginStatus.toString),
          active_status: FormSelectInput$Catalyst.SelectUtils.getSelectComponentItem(filter.active_status, PartnerActiveStatusFilter.to_string),
          msisdn: Belt_Option.getWithDefault(filter.msisdn, ""),
          name: Belt_Option.getWithDefault(filter.driver_name, ""),
          cluster: Belt_Option.getWithDefault(filter.cluster_name, ""),
          vehicle_number: Belt_Option.getWithDefault(filter.vehicle_number, "")
        };
}

var loginStatusOptions = FormSelectInput$Catalyst.SelectUtils.getTypeItems(PartnerLoginStatus.lst, PartnerLoginStatus.toString);

var activeStatusOptions = FormSelectInput$Catalyst.SelectUtils.getTypeItems(PartnerActiveStatusFilter.lst, PartnerActiveStatusFilter.to_string);

function FilterPartnerForm$FormComponent(Props) {
  var vehicleTypes = Props.vehicleTypes;
  var refetchVehicleTypes = Props.refetchVehicleTypes;
  var geoRegions = Props.geoRegions;
  var filter = Props.filter;
  var applyFilter = Props.applyFilter;
  var total_items = Props.total_items;
  var country = Props.country;
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var cityOptions = FilterPartnerFormHelper.getCityOptions(geoRegions);
  var vehicleTypeOptions = FilterPartnerFormHelper.getVehicleOptions(vehicleTypes);
  var form = useForm(getInitialState(cityOptions, vehicleTypeOptions, filter), {
        country: country
      }, (function (output, _submissionCallbacks) {
          var filterPrarms_geo_region_id = output.city;
          var filterPrarms_vehicle_id = output.vehicle_type;
          var filterPrarms_engagement_type = output.engagement_type;
          var filterPrarms_status = output.status;
          var filterPrarms_availability = output.availability;
          var filterPrarms_gps_location = output.gps_location;
          var filterPrarms_active_status = output.active_status;
          var filterPrarms_login_status = output.login_status;
          var filterPrarms_msisdn = output.msisdn;
          var filterPrarms_driver_name = output.name;
          var filterPrarms_cluster_name = output.cluster;
          var filterPrarms_vehicle_number = output.vehicle_number;
          var filterPrarms = {
            geo_region_id: filterPrarms_geo_region_id,
            vehicle_id: filterPrarms_vehicle_id,
            engagement_type: filterPrarms_engagement_type,
            status: filterPrarms_status,
            availability: filterPrarms_availability,
            gps_location: filterPrarms_gps_location,
            active_status: filterPrarms_active_status,
            login_status: filterPrarms_login_status,
            msisdn: filterPrarms_msisdn,
            driver_name: filterPrarms_driver_name,
            cluster_name: filterPrarms_cluster_name,
            vehicle_number: filterPrarms_vehicle_number
          };
          Curry._1(applyFilter, filterPrarms);
          return Curry._1(workspaceDispatch.replaceTab, {
                      TAG: /* FilterPartner */41,
                      _0: FilterPartnerRequest.toDict(filterPrarms)
                    });
        }));
  React.useEffect((function () {
          var city = form.input.city;
          if (city !== undefined) {
            Curry._1(refetchVehicleTypes, Caml_format.caml_int_of_string(city.key));
          }
          
        }), [form.input.city]);
  React.useEffect((function () {
          Curry._1(form.reset, undefined);
          
        }), [filter]);
  return React.createElement("div", {
              className: "filter-driver-form"
            }, React.createElement(FormSelectInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("City", (function ($$event) {
                          return Curry._2(form.updateCity, (function (input, value) {
                                        return {
                                                city: value,
                                                vehicle_type: undefined,
                                                engagement_type: input.engagement_type,
                                                availability: input.availability,
                                                gps_location: input.gps_location,
                                                status: input.status,
                                                login_status: input.login_status,
                                                active_status: input.active_status,
                                                msisdn: input.msisdn,
                                                name: input.name,
                                                cluster: input.cluster,
                                                vehicle_number: input.vehicle_number
                                              };
                                      }), FilterPartnerFormHelper.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), cityOptions));
                        }), undefined, undefined, undefined, undefined, undefined, undefined, form.cityResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  select_props: {
                    value: form.input.city,
                    items: cityOptions,
                    isNoneRequired: false
                  }
                }), React.createElement(FormSelectInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Vehicle", (function ($$event) {
                          return Curry._2(form.updateVehicle_type, (function (input, value) {
                                        return {
                                                city: input.city,
                                                vehicle_type: value,
                                                engagement_type: input.engagement_type,
                                                availability: input.availability,
                                                gps_location: input.gps_location,
                                                status: input.status,
                                                login_status: input.login_status,
                                                active_status: input.active_status,
                                                msisdn: input.msisdn,
                                                name: input.name,
                                                cluster: input.cluster,
                                                vehicle_number: input.vehicle_number
                                              };
                                      }), FilterPartnerFormHelper.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), vehicleTypeOptions));
                        }), undefined, undefined, undefined, undefined, undefined, undefined, form.vehicle_typeResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  select_props: {
                    value: form.input.vehicle_type,
                    items: vehicleTypeOptions,
                    isNoneRequired: true
                  }
                }), React.createElement(FormCheckBoxInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Driver Type", (function ($$event) {
                          return Curry._2(form.updateEngagement_type, (function (input, value) {
                                        return {
                                                city: input.city,
                                                vehicle_type: input.vehicle_type,
                                                engagement_type: value,
                                                availability: input.availability,
                                                gps_location: input.gps_location,
                                                status: input.status,
                                                login_status: input.login_status,
                                                active_status: input.active_status,
                                                msisdn: input.msisdn,
                                                name: input.name,
                                                cluster: input.cluster,
                                                vehicle_number: input.vehicle_number
                                              };
                                      }), FilterPartnerFormHelper.isChecked(form.input.engagement_type, FormHelper$Catalyst.TargetEventWrapper.value($$event)) ? List.filter(function (a) {
                                              return a !== FormHelper$Catalyst.TargetEventWrapper.value($$event);
                                            })(form.input.engagement_type) : ({
                                          hd: FormHelper$Catalyst.TargetEventWrapper.value($$event),
                                          tl: form.input.engagement_type
                                        }));
                        }), undefined, undefined, undefined, undefined, undefined, undefined, form.engagement_typeResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  checkbox_props: {
                    selected: form.input.engagement_type,
                    options: FilterPartnerFormHelper.engagementTypeChecboxes,
                    row_layout: true
                  }
                }), React.createElement(FormCheckBoxInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Availability", (function ($$event) {
                          return Curry._2(form.updateAvailability, (function (input, value) {
                                        return {
                                                city: input.city,
                                                vehicle_type: input.vehicle_type,
                                                engagement_type: input.engagement_type,
                                                availability: value,
                                                gps_location: input.gps_location,
                                                status: input.status,
                                                login_status: input.login_status,
                                                active_status: input.active_status,
                                                msisdn: input.msisdn,
                                                name: input.name,
                                                cluster: input.cluster,
                                                vehicle_number: input.vehicle_number
                                              };
                                      }), FilterPartnerFormHelper.isChecked(form.input.availability, FormHelper$Catalyst.TargetEventWrapper.value($$event)) ? List.filter(function (a) {
                                              return a !== FormHelper$Catalyst.TargetEventWrapper.value($$event);
                                            })(form.input.availability) : ({
                                          hd: FormHelper$Catalyst.TargetEventWrapper.value($$event),
                                          tl: form.input.availability
                                        }));
                        }), undefined, undefined, undefined, undefined, undefined, undefined, form.availabilityResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  checkbox_props: {
                    selected: form.input.availability,
                    options: FilterPartnerFormHelper.availabilityChecboxes,
                    row_layout: false
                  }
                }), React.createElement(FormCheckBoxInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("GPS not Updated", (function ($$event) {
                          return Curry._2(form.updateGps_location, (function (input, value) {
                                        return {
                                                city: input.city,
                                                vehicle_type: input.vehicle_type,
                                                engagement_type: input.engagement_type,
                                                availability: input.availability,
                                                gps_location: value,
                                                status: input.status,
                                                login_status: input.login_status,
                                                active_status: input.active_status,
                                                msisdn: input.msisdn,
                                                name: input.name,
                                                cluster: input.cluster,
                                                vehicle_number: input.vehicle_number
                                              };
                                      }), FilterPartnerFormHelper.isChecked(form.input.gps_location, FormHelper$Catalyst.TargetEventWrapper.value($$event)) ? List.filter(function (a) {
                                              return a !== FormHelper$Catalyst.TargetEventWrapper.value($$event);
                                            })(form.input.gps_location) : ({
                                          hd: FormHelper$Catalyst.TargetEventWrapper.value($$event),
                                          tl: form.input.gps_location
                                        }));
                        }), undefined, undefined, undefined, undefined, undefined, undefined, form.gps_locationResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  checkbox_props: {
                    selected: form.input.gps_location,
                    options: FilterPartnerFormHelper.gpsLocationChecboxes,
                    row_layout: false
                  }
                }), React.createElement(FormCheckBoxInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Status", (function ($$event) {
                          return Curry._2(form.updateStatus, (function (input, value) {
                                        return {
                                                city: input.city,
                                                vehicle_type: input.vehicle_type,
                                                engagement_type: input.engagement_type,
                                                availability: input.availability,
                                                gps_location: input.gps_location,
                                                status: value,
                                                login_status: input.login_status,
                                                active_status: input.active_status,
                                                msisdn: input.msisdn,
                                                name: input.name,
                                                cluster: input.cluster,
                                                vehicle_number: input.vehicle_number
                                              };
                                      }), FilterPartnerFormHelper.isChecked(form.input.status, FormHelper$Catalyst.TargetEventWrapper.value($$event)) ? List.filter(function (a) {
                                              return a !== FormHelper$Catalyst.TargetEventWrapper.value($$event);
                                            })(form.input.status) : ({
                                          hd: FormHelper$Catalyst.TargetEventWrapper.value($$event),
                                          tl: form.input.status
                                        }));
                        }), undefined, undefined, undefined, undefined, undefined, undefined, form.statusResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  checkbox_props: {
                    selected: form.input.status,
                    options: FilterPartnerFormHelper.statusChecboxes,
                    row_layout: true
                  }
                }), React.createElement(FormSelectInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Login Status", (function ($$event) {
                          return Curry._2(form.updateLogin_status, (function (input, value) {
                                        return {
                                                city: input.city,
                                                vehicle_type: input.vehicle_type,
                                                engagement_type: input.engagement_type,
                                                availability: input.availability,
                                                gps_location: input.gps_location,
                                                status: input.status,
                                                login_status: value,
                                                active_status: input.active_status,
                                                msisdn: input.msisdn,
                                                name: input.name,
                                                cluster: input.cluster,
                                                vehicle_number: input.vehicle_number
                                              };
                                      }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), loginStatusOptions));
                        }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  select_props: {
                    value: form.input.login_status,
                    items: loginStatusOptions,
                    isNoneRequired: true
                  }
                }), React.createElement(FormSelectInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Active Status", (function ($$event) {
                          return Curry._2(form.updateActive_status, (function (input, value) {
                                        return {
                                                city: input.city,
                                                vehicle_type: input.vehicle_type,
                                                engagement_type: input.engagement_type,
                                                availability: input.availability,
                                                gps_location: input.gps_location,
                                                status: input.status,
                                                login_status: input.login_status,
                                                active_status: value,
                                                msisdn: input.msisdn,
                                                name: input.name,
                                                cluster: input.cluster,
                                                vehicle_number: input.vehicle_number
                                              };
                                      }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), activeStatusOptions));
                        }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  select_props: {
                    value: form.input.active_status,
                    items: activeStatusOptions,
                    isNoneRequired: true
                  }
                }), React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("MSISDN", (function ($$event) {
                          return Curry._2(form.updateMsisdn, (function (input, value) {
                                        return {
                                                city: input.city,
                                                vehicle_type: input.vehicle_type,
                                                engagement_type: input.engagement_type,
                                                availability: input.availability,
                                                gps_location: input.gps_location,
                                                status: input.status,
                                                login_status: input.login_status,
                                                active_status: input.active_status,
                                                msisdn: value,
                                                name: input.name,
                                                cluster: input.cluster,
                                                vehicle_number: input.vehicle_number
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), undefined, undefined, "Enter msisdn", undefined, undefined, undefined, form.msisdnResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: form.input.msisdn
                  }
                }), React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Name", (function ($$event) {
                          return Curry._2(form.updateName, (function (input, value) {
                                        return {
                                                city: input.city,
                                                vehicle_type: input.vehicle_type,
                                                engagement_type: input.engagement_type,
                                                availability: input.availability,
                                                gps_location: input.gps_location,
                                                status: input.status,
                                                login_status: input.login_status,
                                                active_status: input.active_status,
                                                msisdn: input.msisdn,
                                                name: value,
                                                cluster: input.cluster,
                                                vehicle_number: input.vehicle_number
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), undefined, undefined, "Enter name", undefined, undefined, undefined, form.nameResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: form.input.name
                  }
                }), React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Cluster", (function ($$event) {
                          return Curry._2(form.updateCluster, (function (input, value) {
                                        return {
                                                city: input.city,
                                                vehicle_type: input.vehicle_type,
                                                engagement_type: input.engagement_type,
                                                availability: input.availability,
                                                gps_location: input.gps_location,
                                                status: input.status,
                                                login_status: input.login_status,
                                                active_status: input.active_status,
                                                msisdn: input.msisdn,
                                                name: input.name,
                                                cluster: value,
                                                vehicle_number: input.vehicle_number
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), undefined, undefined, "Enter cluster", undefined, undefined, undefined, form.clusterResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: form.input.cluster
                  }
                }), React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Vehicle Number", (function ($$event) {
                          return Curry._2(form.updateVehicle_number, (function (input, value) {
                                        return {
                                                city: input.city,
                                                vehicle_type: input.vehicle_type,
                                                engagement_type: input.engagement_type,
                                                availability: input.availability,
                                                gps_location: input.gps_location,
                                                status: input.status,
                                                login_status: input.login_status,
                                                active_status: input.active_status,
                                                msisdn: input.msisdn,
                                                name: input.name,
                                                cluster: input.cluster,
                                                vehicle_number: value
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), undefined, undefined, "Enter Vehicle Number (last 4 digits)", undefined, undefined, undefined, form.vehicle_numberResult, undefined, "vehicle-number-input", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: form.input.vehicle_number
                  }
                }), React.createElement("div", {
                  className: "apply-button-container"
                }, React.createElement("p", {
                      className: "results-found"
                    }, String(total_items) + " results found"), React.createElement("div", {
                      className: "same-row-button"
                    }, React.createElement(Button$Catalyst.make, {
                          text: "Apply",
                          cb: (function (_event) {
                              return Curry._1(form.submit, undefined);
                            }),
                          className: "btn-primary apply-button"
                        }))));
}

var FormComponent = {
  loginStatusOptions: loginStatusOptions,
  activeStatusOptions: activeStatusOptions,
  make: FilterPartnerForm$FormComponent
};

function FilterPartnerForm$VehicleTypesWrapper(Props) {
  var geoRegions = Props.geoRegions;
  var filter = Props.filter;
  var applyFilter = Props.applyFilter;
  var total_items = Props.total_items;
  var country = Props.country;
  var VehicleRepo = VehicleRepoManager.getRepo(undefined);
  var city = filter.geo_region_id;
  var match = Curry._2(VehicleRepo.useVehicleTypes, city !== undefined ? List.find((function (c) {
                return city === c.id;
              }), geoRegions).id : List.nth(geoRegions, 0).id, country);
  var refetchVehicleTypes = match[1];
  return React.createElement(FetchLoadableViewMapper$Catalyst.make, {
              loadableData: match[0],
              children: (function (vehicleTypes) {
                  return React.createElement(FilterPartnerForm$FormComponent, {
                              vehicleTypes: vehicleTypes,
                              refetchVehicleTypes: refetchVehicleTypes,
                              geoRegions: geoRegions,
                              filter: filter,
                              applyFilter: applyFilter,
                              total_items: total_items,
                              country: country
                            });
                })
            });
}

var VehicleTypesWrapper = {
  make: FilterPartnerForm$VehicleTypesWrapper
};

function FilterPartnerForm(Props) {
  var filter = Props.filter;
  var applyFilter = Props.applyFilter;
  var total_items = Props.total_items;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var GeoRegionRepo = GeoRegionRepoManager.getRepo(undefined);
  var geoRegions = Curry._1(GeoRegionRepo.useGeoRegions, country);
  return React.createElement(FetchLoadableViewMapper$Catalyst.make, {
              loadableData: geoRegions,
              children: (function (geoRegions) {
                  if (geoRegions) {
                    return React.createElement(FilterPartnerForm$VehicleTypesWrapper, {
                                geoRegions: geoRegions,
                                filter: filter,
                                applyFilter: applyFilter,
                                total_items: total_items,
                                country: country
                              });
                  } else {
                    return React.createElement("div", undefined, "No Geo Regions found");
                  }
                })
            });
}

var make = FilterPartnerForm;

export {
  saveButton ,
  saveButtonDisabled ,
  Form ,
  getInitialState ,
  FormComponent ,
  VehicleTypesWrapper ,
  make ,
  
}
/* saveButton Not a pure module */
